import { memo } from 'react'
import { DraftBlockType, EditorState } from 'draft-js'
import { StyleTypes } from '../types'
import { ToolbarContainer, ToolbarDiv, ToolbarLeft } from './styles'
import { useToolbarActions } from './useToolbarActions'
import { useToolbarRenders } from './useToolbarRenders'

export interface Props {
  editorState: EditorState
  onToggleInline: (inlineStyle: StyleTypes) => void
  onToggleBlock: (blockType: DraftBlockType) => void
  onChange: (editorStateProp: EditorState) => void
  focusEditor: () => void
  onToggleSpellChecker: () => void
  isSpellCheckerEnabled: boolean
  isSpellCheckerVisible: boolean
  isSpellCheckerPending: boolean
  boldButtonDisable: boolean
  italicButtonDisable: boolean
  linkButtonDisable: boolean
  additionalToolbarActions?: JSX.Element | null
}

const RichTextToolbar = (props: Props) => {
  const {
    boldButtonDisable,
    italicButtonDisable,
    linkButtonDisable,
    isSpellCheckerVisible,
    additionalToolbarActions,
  } = props

  const actions = useToolbarActions(props)

  const { renderBlockButton, renderLinkButton, renderMarkButton, renderSpellCheckButton } =
    useToolbarRenders({ ...props, actions })

  return (
    <ToolbarContainer data-testid="rich-text-toolbar">
      <ToolbarLeft>
        {!boldButtonDisable && renderMarkButton(StyleTypes.Bold)}
        {!italicButtonDisable && renderMarkButton(StyleTypes.Italic)}
        {renderMarkButton(StyleTypes.Underline)}
        {renderMarkButton(StyleTypes.Strike)}
        <ToolbarDiv />
        {renderBlockButton(StyleTypes.OrderedList)}
        {renderBlockButton(StyleTypes.UnorderedList)}
        {!linkButtonDisable && <ToolbarDiv />}
        {!linkButtonDisable && renderLinkButton()}
        {isSpellCheckerVisible && <ToolbarDiv />}
        {isSpellCheckerVisible && renderSpellCheckButton()}
      </ToolbarLeft>
      {additionalToolbarActions}
    </ToolbarContainer>
  )
}

export default memo(RichTextToolbar)
